import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGemini = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.33337 6.66675C9.27608 9.03659 13.3304 10.6667 18.0171 10.6667C22.6766 10.6667 26.7109 9.05554 28.6667 6.70811M28.6667 29.3334C26.724 26.9636 22.6697 25.3334 17.983 25.3334C13.3235 25.3334 9.28918 26.9446 7.33338 29.2921M13.3334 11.3334V24.6667M22.6667 11.3334V24.6667",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGemini;
